import { useEffect, useState } from 'react';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { apiRequest } from '../api/client.js';
import { useSession } from '../features/auth/session.js';

export function Layout(): React.JSX.Element {
  const { sesion, cerrarSesion } = useSession();
  const navigate = useNavigate();
  const [saliendo, setSaliendo] = useState(false);
  // El enlace a identidades solo aparece si el servidor habilita el creador virtual.
  const [creadorVirtual, setCreadorVirtual] = useState(false);
  useEffect(() => {
    if (sesion.estado !== 'autenticado') return;
    void apiRequest<{ available: string[] }>('/project-types')
      .then((r) => setCreadorVirtual(r.available.includes('VIRTUAL_CREATOR')))
      .catch(() => setCreadorVirtual(false));
  }, [sesion.estado]);

  async function salir(): Promise<void> {
    setSaliendo(true);
    try {
      await cerrarSesion();
      void navigate('/entrar', { replace: true });
    } finally {
      setSaliendo(false);
    }
  }

  return (
    <div style={{ margin: '0 auto', maxWidth: '60rem', padding: '1rem' }}>
      <header
        style={{
          display: 'flex',
          alignItems: 'baseline',
          gap: '1.5rem',
          borderBottom: '1px solid var(--borde)',
          paddingBottom: '0.5rem',
        }}
      >
        <strong>
          <Link to="/">Generador de Contenido IA</Link>
        </strong>
        {sesion.estado === 'autenticado' && (
          <nav style={{ display: 'flex', gap: '1rem' }}>
            <Link to="/">Panel</Link>
            <Link to="/biblioteca">Biblioteca</Link>
            {creadorVirtual && <Link to="/identidades">Identidades</Link>}
            <Link to="/ajustes">Ajustes IA</Link>
            <Link to="/estado">Estado</Link>
          </nav>
        )}
        {sesion.estado === 'autenticado' && (
          <button type="button" onClick={() => void salir()} disabled={saliendo}>
            {saliendo ? 'Saliendo…' : 'Cerrar sesión'}
          </button>
        )}
      </header>
      <main style={{ paddingTop: '1rem' }}>
        <Outlet />
      </main>
    </div>
  );
}
